import React from 'react';
import { Box, Typography, Container } from '@mui/material';

export const Footer: React.FC = () => {
  return (
    <Box component='footer' sx={{
      py: 2, px: 2, mt: 'auto',
      backgroundColor: (theme) => theme.palette.mode === 'light'
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
    }}>
      <Container maxWidth='lg'>
        <Typography variant='body2' color='text.secondary' align='center'>
          © {new Date().getFullYear()} SR Real Estate Services. All rights reserved.
        </Typography>
        <Typography variant='caption' color='text.secondary' align='center' display='block'>
          SR REAL ESTATE SERVICES LLC · Formerly Solutions & Researches Pro
        </Typography>
        <Typography variant='body2' color='text.secondary' align='center'>
          Version 1.0.0
        </Typography>
      </Container>
    </Box>
  );
};
